module.exports = __webpack_public_path__ + "static/img/end_pingan_gj_icon.1edda549.png";